import { axiosFn, handleError } from "../index"
import { makeFilterString } from "../Helper/Helper"
import * as URL from "../URLs"

export async function CountryAPI(filter = {}) {
    return await axiosFn("get", URL.lookups + URL.countries + makeFilterString(filter))
        .then((res) => {
            return {
                res: res.data,
                err: null,
            }
        })
        .catch(handleError)
}
